if (typeof global !== "undefined" && global.__pretenderNodePolyfill) {
  delete global.self
  delete global.__pretenderNodePolyfill
}



//////////////////
// WEBPACK FOOTER
// ./~/@miragejs/pretender-node-polyfill/after.js
// module id = 595
// module chunks = 158